import React from 'react';
import * as msgpub from "msgpub";
import { TextArea, QoS, ButtonG } from '../Common';
import { DisablesContext } from '../../constant/UserMqtt';
import { LabelResult } from 'msgpub/dist/src/msgpub/Common';
import { Grid, Box, TextInput, ResponsiveContext } from 'grommet';
import { MainStyleForGrommet } from '../../constant/Styles';
import { status_mapper, apptopicstatus_mapper } from '../../common/common';

interface SubProps{
    user?: msgpub.User;
    setLog: any;
    setRecv: any;
}

const AREAS: {[key: string]: any[]} = {
    small: [
        { name: 'col1', start: [0, 0], end: [1, 0] },
        { name: 'col2', start: [0, 1], end: [1, 1] },
        { name: 'col3', start: [0, 2], end: [1, 2] },
        { name: 'col4', start: [0, 3], end: [1, 3] },
    ],
    medium: [
        { name: 'col1', start: [0, 0], end: [1, 0] },
        { name: 'col2', start: [1, 0], end: [2, 0] },
        { name: 'col3', start: [2, 0], end: [3, 0] },
        { name: 'col4', start: [3, 0], end: [4, 0] },
    ],
    large: [
        { name: 'col1', start: [0, 0], end: [1, 0] },
        { name: 'col2', start: [1, 0], end: [2, 0] },
        { name: 'col3', start: [2, 0], end: [3, 0] },
        { name: 'col4', start: [3, 0], end: [4, 0] },
    ]
};

// サイズ
const QoS_WIDTH = "220px";
const SUB_BUTTON_WIDTH = "150px";
const UNSUB_BUTTON_WIDTH = "180px";

const ROWS: {[key: string]: any[]} = {
    small: ['auto', 'auto', 'auto', 'auto'],
    medium: ['auto'],
    large: ['auto']
};

const COLUMNS: {[key: string]: any[]} = {
    small: ['auto'],
    medium: ['flex', QoS_WIDTH, SUB_BUTTON_WIDTH, UNSUB_BUTTON_WIDTH],
    large: ['flex', QoS_WIDTH, SUB_BUTTON_WIDTH, UNSUB_BUTTON_WIDTH]
}

function Sub(props: {props: SubProps}){
    const {user, setLog, setRecv} = props.props;
    const [topic, setTopic] = React.useState("");
    const [label, setLabel] = React.useState("");
    const [qosForTopic, setQosForTopic] = React.useState(msgpub.QoS.AT_MOST_ONCE);
    const [qosForLabel, setQosForLabel] = React.useState(msgpub.QoS.AT_MOST_ONCE);
    const disables = React.useContext(DisablesContext);
    const size = React.useContext(ResponsiveContext);
    const areas = AREAS[size];
    const rows = ROWS[size];
    const columns = COLUMNS[size];

    if (user !== undefined) {
        user.setReceiveCallback((app, topic, qos, message, retain, dup) => {
            setRecv((prevRecv: string) => (prevRecv + "message received. app = " + app + ", topic = " + 
                                topic + ", qos = " + qos + ", retain = " + retain + ", dup = " + dup + "\n"));
            if (message.length === 0) {
                setRecv((prevRecv: string) => (prevRecv + "no retained data\n"));
            } else {
                let decodedMsg = "";
                for(var i = 0; i < message.length; ++i) {
                    if (message[i] <= 32 || message[i] > 127) {
                        decodedMsg += "\\x" + ("00" + message[i].toString(16)).slice(-2);;
                    } else {
                        decodedMsg += String.fromCharCode(message[i]);
                    }
                }
                setRecv((prevRecv: string) => (prevRecv + "message = " + decodedMsg + "\n"));
            }
        });
    }

    const subscribeForTopic = () => {
        const appTopic = topic.split(":");
	const topicOption = appTopic.length === 1 ? { topic: topic } : {topic: appTopic[1], app: appTopic[0] };
        user?.subscribe({
            params: { at: topicOption, option: { qos: qosForTopic } },
            callback: (status) => {
                setLog((prevLog: string) => (prevLog + "subscribe status = " + JSON.stringify(status) + "\n"));
            }
        });
    };

    const subscribeForLabel = () => {
        const appLabel = label.split(":");
	const labelOption = appLabel.length === 1 ? { label: label } : { label: appLabel[1], app: appLabel[0] };
        user?.subscribe({
            params: { al: labelOption, option: { qos: qosForLabel } },
            callback: (status) => {
                // @ts-ignore
                //labelResult["status"] = status_mapper(labelResult["status"]);
                //labelResult["appTopicStatusList"] = apptopicstatus_mapper(labelResult["appTopicStatusList"]);
                //setLog((prevLog: string) => (prevLog + "LabelResult = " + JSON.stringify(labelResult) + "\n"));            },
                setLog((prevLog: string) => (prevLog + "subscribe status = " + JSON.stringify(status) + "\n"));
	    }
        });
    };

    const unsubscribeForTopic = () => {
        const appTopic = topic.split(":");
	const topicOption = appTopic.length === 1 ? { topic: topic } : {topic: appTopic[1], app: appTopic[0] };
        user?.unsubscribe(
	    { at: topicOption },
	    (result: msgpub.UnsubscribeResultEntry[]) => {
                setLog((prevLog: string) => (prevLog + "unsubscribe result = " + JSON.stringify(result) + "\n"))
	});
    };

    const unsubscribeForLabel = () => {
        const appLabel = label.split(":");
	const labelOption = appLabel.length === 1 ? { label: label } : { label: appLabel[1], app: appLabel[0] };
        user?.unsubscribe(
            { al: labelOption },
	    (result: msgpub.UnsubscribeResultEntry[]) => {
                setLog((prevLog: string) => (prevLog + "unsubscribe result = " + JSON.stringify(result) + "\n"))
        });
    };

    const onChangeForTopic = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTopic(event.target.value);
    }

    const onChangeForLabel = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLabel(event.target.value);
    }

    return (
        <div>
            <Box {...MainStyleForGrommet}>
                <Grid
                        rows={rows}
                        columns={columns}
                        gap="xsmall"
                        areas={areas}
                >
                    <Box gridArea="col1">
                        <TextInput placeholder="topic" size="small" value={topic} onChange={onChangeForTopic} disabled={disables.sub}/>
                    </Box>
                    <Box gridArea="col2" style={{width: QoS_WIDTH}}>
                        <QoS setQos={setQosForTopic} disabled={disables.sub} />
                    </Box>
                    <Box gridArea="col3" style={{width: SUB_BUTTON_WIDTH}}>
                        <ButtonG name="sub topic" callback={subscribeForTopic} disabled={disables.sub} />
                    </Box>
                    <Box gridArea="col4" style={{width: UNSUB_BUTTON_WIDTH}}>
                        <ButtonG name="unsub topic" callback={unsubscribeForTopic} disabled={disables.sub} />
                    </Box>
                </Grid>
                <Grid
                        rows={rows}
                        columns={columns}
                        gap="xsmall"
                        areas={areas}
                >
                    <Box gridArea="col1">
                        <TextInput placeholder="label" size="small" value={label} onChange={onChangeForLabel} disabled={disables.sub}/>
                    </Box>
                    <Box gridArea="col2" style={{width: QoS_WIDTH}}>
                        <QoS setQos={setQosForLabel} disabled={disables.sub} />
                    </Box>
                    <Box gridArea="col3" style={{width: SUB_BUTTON_WIDTH}}>
                        <ButtonG name="sub label" callback={subscribeForLabel} disabled={disables.sub} />
                    </Box>
                    <Box gridArea="col4" style={{width: UNSUB_BUTTON_WIDTH}}>
                        <ButtonG name="unsub label" callback={unsubscribeForLabel} disabled={disables.sub}/>
                    </Box>
                </Grid>
            </Box>
        </div>
    );
}

export default function SubscribeComponent(props: {user?: msgpub.User, setRecv: any, log: string, setLog: any}) {
    const {user, setRecv, log, setLog} = props;
    const thisProps: SubProps = {user: user, setLog: setLog, setRecv: setRecv};
    const disables = React.useContext(DisablesContext);

    return(
        <div>
            <Sub props={thisProps} />
            <TextArea texts={log} name={"Subscribe log"} disabled={disables.sub} id={"sublog"} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setLog(e.target.value)}}/>
        </div>
    );
}
